function Skills ()
    {
        return (
                <div id="Skills">
                    <h2>Mes compétences</h2>
                    <p>Les différents projets pendant la formation m'ont permis de développer des compétences tant au niveau front-end que back-end.</p>
                    <p>J'ai ainsi pu développer des connaissances sur les langages tels que le HTML, CSS, JavaScript pour enfin                     
                    m'orienter vers une stack MERN (MongoDB, Express, React Node).</p>

                    <p>J'ai aussi été amené avant la formation à m'interesser au PHP, à MySQL.</p>

                    <p>Aussi, ayant soif de connaissances, je reste ouvert à l'apprentissage et l'utilisation des différentes technologies disponibles.</p>

                    <p>Ma longue experience en tant que Demomaker m'a amené à m'intéresser au design et au graphisme.</p>

                    <p>Ancien commerçant, je suis aussi à l'aise pour m'exprimer en publique et avec la clientelle. Mes differentes expériences professionnelles m'ont 
                        permis de développer un sens aigu du travail bien fait, du travail en équipe et de l'organisation.</p>
                </div>
            )
    }

    export default Skills